import React from "react";
import styles from "./Schedules.module.scss";
import LArrow from "../../../../assets/img/roundedArrowL.png";
import RArrow from "../../../../assets/img/roundedArrowR.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
//import "slick-carousel/slick/slick-theme.css";
import "../../../../assets/styles/slick-theme.scss";
import Fade from "@material-ui/core/Fade";

class Schedules extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      schedules: null,
      currentPage: 0,
    };
  }

  componentDidMount() {
    this.connectSchedules();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.lawyer &&
      this.props.lawyer &&
      prevProps.lawyer.id != this.props.lawyer.id
    ) {
      this.connectSchedules();
    }
  }

  connectSchedules() {
    let _day = null;
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let found = false;
    let combined = [];

    this.props.schedules.map((day) => {
      _day = new Date(day.date);
      _day.setHours(0, 0, 0, 0);
      found = false;

      if (_day >= today) {
        combined.filter((singleDay) => {
          let tmpDay = new Date(singleDay.day);

          if (
            tmpDay.getFullYear() === _day.getFullYear() &&
            tmpDay.getMonth() === _day.getMonth() &&
            tmpDay.getDate() === _day.getDate()
          ) {
            singleDay.list = singleDay.list.concat(day.list);

            singleDay.list.sort(function (a, b) {
              var dateA = new Date(a.start),
                dateB = new Date(b.start);
              return dateA - dateB;
            });
            found = true;
          }
        });

        if (!found) {
          combined.push({
            day: _day,
            list: day.list,
          });
        }
      }
    });

    this.setState({
      combinedSchedules: combined,
    });
  }

  changeDay = (direction) => {
    if (
      direction === "next" &&
      this.state.currentPage < this.props.schedules.length
    ) {
      this.setState({
        currentPage: this.state.currentPage + 1,
      });
    } else if (direction === "prev" && this.state.currentPage) {
      this.setState({
        currentPage: this.state.currentPage - 1,
      });
    }
  };

  compareDay = (day) => {
    let days = ["Pon.", "Wt.", "Śr.", "Czw.", "Pt.", "Sob.", "Niedz."];
    let today = new Date();
    //today.setHours(0,0,0,0);
    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    let afterTomorrow = new Date();
    afterTomorrow.setDate(tomorrow.getDate() + 1);

    day = new Date(day);

    if (
      day.getFullYear() === today.getFullYear() &&
      day.getMonth() === today.getMonth() &&
      day.getDate() === today.getDate()
    )
      return <div>Dziś</div>;
    else if (
      day.getFullYear() === tomorrow.getFullYear() &&
      day.getMonth() === tomorrow.getMonth() &&
      day.getDate() === tomorrow.getDate()
    )
      return <div>Jutro</div>;
    else {
      return days[day.getDay() - 1];
    }
  };

  render() {
    const { schedules, toggleOrder } = this.props;
    const { combinedSchedules } = this.state;

    let Hour = null;
    //let endHour = null;
    let months = [
      "Sty",
      "Lut",
      "Mar",
      "Kwi",
      "Maj",
      "Cze",
      "Lip",
      "Sie",
      "Wrz",
      "Paź",
      "Lis",
      "Gru",
    ];
    let Day = null;
    let now = new Date();

    var settings = {
      dots: false,
      arrows: true,
      infinite: false,
      speed: 0,
      slidesToShow: 6,
      slidesToScroll: 6,
      draggable: false,
      nextArrow: <img src={RArrow} alt="right" className={styles.nextDay} />,
      prevArrow: <img src={LArrow} alt="left" className={styles.prevDay} />,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
          },
        },
        {
          breakpoint: 540,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
      ],
    };
    return (
      <Fade in={true} timeout={800}>
        <div className={styles.Schedules}>
          {combinedSchedules && (
            <div className={styles.dateSelector}>
              <Slider {...settings}>
                {combinedSchedules.map((day) => {
                  Day = new Date(day.day);
                  return (
                    <div className={styles.column} key={day}>
                      <div className={styles.head}>
                        <div className={styles.day}>{this.compareDay(Day)}</div>
                        <div className={styles.shortDate}>
                          {Day.getDate()} {months[Day.getMonth()]}
                        </div>
                      </div>
                      <div className={styles.hours}>
                        {day.list.map((hour) => {
                          Hour = new Date(hour.start);
                          //endHour = new Date(hour.end);
                          // if(Hour >= now  && !hour.reserved) {
                          const free =
                            hour.free && Hour >= now && !hour.reserved;
                          return (
                            <div
                              className={free ? styles.free : styles.nofree}
                              onClick={() => {
                                if (free)
                                  toggleOrder(
                                    new Date(hour.start),
                                    new Date(hour.end),
                                    true,
                                    this.props.domain
                                  );
                              }}
                            >
                              {Hour.getHours()} :{" "}
                              {Hour.getMinutes() < 10
                                ? "0" + Hour.getMinutes()
                                : Hour.getMinutes()}
                            </div>
                          );
                          //}
                        })}
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>
          )}
        </div>
      </Fade>
    );
  }
}

Schedules.defaultProps = {};

export default Schedules;
